// PageContainer.jsx
import { Box } from "@mui/material";

export default function PageContainer({ children, maxWidth = "lg" }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth,
        margin: "0 auto",
        padding: {
          xs: "12px",
          sm: "16px",
          md: "24px",
        },
        minHeight: "100%",
      }}
    >
      {children}
    </Box>
  );
}
